export const tdsConstants = {
  TDSS_LOADED: 'TDSS_LOADED',
  TDS_LOADED: 'TDS_LOADED',
  TDS_CREATED: 'TDS_CREATED',
  TDS_UPDATED: 'TDS_UPDATED',
  TDS_DELETED: 'TDS_DELETED',
  TDS_ERRORS: 'TDS_ERRORS',
  TDS_RESET: 'TDS_RESET'
};



// WEBPACK FOOTER //
// ./src/_constants/tds.constants.js